import { SagaIterator } from 'redux-saga';
import { call, select, take, takeEvery } from 'redux-saga/effects';
import {
  GlobalAction,
  GlobalActions,
  GlobalPut,
  ModalCloseReason,
  ModalRequested,
  ModalType
} from '@ps20-frontend/shop-integration-redux';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { App } from '@ps20-frontend/frontend-models';
import { IAppState } from '../localStore';
import contentDefault from '../../data/content-default.json';

export function* watchShowModalRequestedTrigger(): SagaIterator {
  yield takeEvery(GlobalActions.MODAL_REQUESTED, safeSaga(openModal, App.SHOP));
  yield takeEvery(
    GlobalActions.SHOP_MODAL_STATUS_REQUESTED,
    safeSaga(provideModalStatus, App.SHOP),
  );
}

export function* openModal(action: GlobalAction<ModalRequested>): SagaIterator {
  const state: IAppState = yield select();
  if (state.transientState.modal.modalOpen) {
    yield take(GlobalActions.CLOSE_MODAL);
  }

  const modelType = action.payload.type;

  const modalOptions = getModalOptions(modelType, action.payload.options);
  const _modalTextContent = getModalContent(modelType, action.payload.content);
  const modalTextContent = handleOptions(_modalTextContent, modalOptions, {
    correlationId: state.saveProtocol.correlationId,
  });

  const modalStyle = getModalStyle(modelType, action.payload.style);

  const globalPut = GlobalPut.getInstance();
  yield call(
    [globalPut, globalPut.put],
    new GlobalActions().showModal({
      textContent: modalTextContent,
      styleObject: modalStyle,
      disableClose: modalOptions.disableClose,
    }),
  );

  if (modelType === ModalType.PS10_VERTRAEGE_HINWEIS) {
    const closeModalAction = yield take(GlobalActions.CLOSE_MODAL);
    if (closeModalAction?.payload === ModalCloseReason.PRIMARY) {
      yield call(
        [globalPut, globalPut.put],
        new GlobalActions().navigateToCheckoutRequested(),
      );
    }
  }
}

export function* provideModalStatus(): SagaIterator {
  const appState: IAppState = yield select();
  const globalPut = GlobalPut.getInstance();
  yield call(
    [globalPut, globalPut.put],
    new GlobalActions().globalModalStatusRecieved(appState.transientState.modal.modalOpen),
  );
}


export function getModalContent(modalType: ModalType, content: ModalRequested['content'] = {}) {
  const modalItems = contentDefault.modal as unknown as Record<string, { text: Record<string, unknown>; style: Record<string, unknown>; options: Record<string, unknown> }>;
  const modalTextItem = modalItems[modalType].text;
  return {
    ...modalTextItem,
    ...content,
  };
}

export function handleOptions(
  modalContent: ModalRequested['content'],
  modalOptions: ModalRequested['options'],
  context: { correlationId: string },
) {
  if (modalOptions.addCorrelationIdToSubheadline !== false) {
    return {
      ...modalContent,
      subheadline: modalContent.subheadline
        ? `${modalContent.subheadline}${context.correlationId}`
        : null,
      body: modalOptions.addIdentifikationsnummer
        ? `${modalContent.body}${' ' + context.correlationId}`
        : `${modalContent.body}`,
    };
  }
  return modalContent;
}

export function getModalStyle(modalType: ModalType, style: ModalRequested['style'] = {}) {
  const modalItems = contentDefault.modal as unknown as Record<string, { text: Record<string, unknown>; style: Record<string, unknown>; options: Record<string, unknown> }>;
  const modalStyleItem = modalItems[modalType].style;
  return {
    ...modalStyleItem,
    ...style,
  };
}

export function getModalOptions(modalType: ModalType, style: ModalRequested['options'] = {}) {
  const modalItems = contentDefault.modal as unknown as Record<string, { text: Record<string, unknown>; style: Record<string, unknown>; options: Record<string, unknown> }>;
  const modalOptionItem = modalItems[modalType].options;
  return {
    ...modalOptionItem,
    ...style,
  };
}
